import React from "react";

import { useTableKeyboardNavigation } from "@progress/kendo-react-data-tools";
import {
  // eslint-disable-next-line no-unused-vars
  GridCellProps,
  GRID_COL_INDEX_ATTRIBUTE,
} from "@progress/kendo-react-grid";
import { Input } from "@progress/kendo-react-inputs";

/**
 *
 * @param {GridCellProps} props
 * @returns
 */
export default function GridTextCell(props) {
  const value = props.dataItem[props.field];
  const navigationAttributes = useTableKeyboardNavigation(props.id);
  const inEdit = props.dataItem.inEdit;
  const handleChange = (e) => {
    if (props.onChange) {
      props.onChange({
        dataIndex: props.dataIndex,
        dataItem: props.dataItem,
        field: props.field,
        syntheticEvent: e.syntheticEvent,
        value: e.target.value,
      });
    }
  };
  return (
    <td
      style={{ whiteSpace: "nowrap" }}
      title={value}
      aria-selected={props.isSelected}
      colSpan={props.colSpan}
      aria-colindex={props.ariaColumnIndex}
      {...{ [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex }}
      {...navigationAttributes}
    >
      {inEdit ? (
        <Input value={value || ""} onChange={handleChange} name={props.field} />
      ) : (
        value || (!props.required ? "-" : "")
      )}
    </td>
  );
}
